/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import { MuiThemeProvider,createMuiTheme } from 'material-ui/styles';
import {green,red} from 'material-ui/colors';
import TermOfService from './termofservice.js';
import Form from './form.js';

const theme = createMuiTheme({
  palette: {
    primary: {
      500: '#fde050'
    },
    secondary: {
      ...green,
      A400: '#00e677',
    },
    error: red,
  },
});


class HomePage extends React.Component {

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <TermOfService />
      </MuiThemeProvider>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/homepage.js